import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginatedPopulatedAboutMeQuestionResponse, PopulatedAboutMeQuestionResponse } from '@libs/about-me/config';
import { Observable, map } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';

@Injectable({
  providedIn: 'root',
})
export class AboutMeService {
  private readonly apiUrl: string = '';

  constructor(
    private readonly http: HttpClient,
    private readonly environmentService: EnvironmentService,
  ) {
    this.apiUrl = this.environmentService.usersServiceUrl + '/about-me';
  }

  /**
   * Get all categories with pagination and filtering
   */
  getAllAnswers(forPopup = false): Observable<any[]> {
    return this.http
      .get<PaginatedPopulatedAboutMeQuestionResponse[]>(this.apiUrl + '/answers', { params: { forPopup } })
      .pipe(
        map((response) => {
          // Ensure the response matches our expected structure
          return response;
        }),
      );
  }


  editAnswer(answer: any, id: string): Observable<any> {
    const requestBody: any = {
      question: answer.question,
      text: answer.text,
      options: answer.options,
      yesOrNot: answer.yesOrNot,
    }
    return this.http.put<PopulatedAboutMeQuestionResponse>(`${this.apiUrl}/answers/${id}`, requestBody).pipe(
      map((response) => {
        // Handle the response as needed
        return response;
      }),
    );
  }

  createAnswer(answer: any): Observable<PopulatedAboutMeQuestionResponse> {
    console.log('Creating answer with:', answer); // Debugging log

    return this.http.post<PopulatedAboutMeQuestionResponse>(`${this.apiUrl}/answers`, answer).pipe(
      map((response) => {
        // Handle the response as needed
        return response;
      }),
    );
  }
}
